<page-load-header *ngIf="!initialized"></page-load-header>

<ng-container *ngIf="initialized">
  <div>
    <header>
      <!-- Fixed navbar -->
      <nav class="navbar nowrap navbar-expand-md navbar-light bg-white">
        <a class="navbar-brand event-title text-truncate cursor-pointer"
          >{{ event.title }} - {{ event.instructor.fullName }} <span *ngIf="event.instructor.pronouns"> ({{ event.instructor.pronouns }})</span></a
        >
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarCollapse">
          <!-- <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#">Link</a>
          </li>
          <li class="nav-item">
            <a class="nav-link disabled" href="#">Disabled</a>
          </li>
        </ul> -->
          <div class="form-inline ml-auto mt-2 mt-md-0">
            <!-- <button type="button" (click)="shareSlides()" class="btn btn-icon text-muted transition-3d-hover">
              <h3><span class="fas fa-camera btn-icon__inner"></span></h3>
            </button> -->
            <button type="button" (click)="fullscreen()" class="btn btn-icon text-muted transition-3d-hover">
              <h3><span class="fas fa-compress-wide btn-icon__inner"></span></h3>
            </button>

            <button type="button" class="btn btn-icon" (click)="exitPage()">
              <h3 class="m-0 text-muted"><i class="fas fa-times"></i></h3>
            </button>
          </div>
        </div>
      </nav>
    </header>
    <main id="live-event" class="main-container">
      <div class="main-theater">
        <div class="row no-gutters">
          <div class="col text-center video-container" #fullscreenContainer >
            <div id="webRTCLayoutContainer" #webRTCLayoutContainer style="background-color: #000;">&nbsp;</div>
          </div>
          <footer class="live-footer">
            <div class="row no-gutters">
              <div class="col pl-2 pr-2">
                <div class="d-flex">
                  <div class="mr-auto">
                    <div class="align-middle">
                      <ul class="list-inline mb-0">
                        <li *ngIf="!this.screenPublisher" class="list-inline-item mr-2">
                          <button type="button" (click)="shareSlides()" class="btn btn-xs btn-success"><i class="fas fa-play-circle"></i> Share Slides</button>
                        </li>
                        <li *ngIf="this.screenPublisher" class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Leave Video">
                          <button type="button" (click)="stopSharing()" class="btn btn-xs btn-outline-danger transition-3d-hover"><i class="fas fa-video-slash"></i> Stop Sharing</button>
                        </li>
                        <li class="list-inline-item mr-2" data-toggle="tooltip" data-placement="top" title="" data-original-title="Settings">
                          <button type="button" (click)="showDeviceSettings()" class="btn btn-xs btn-icon btn-secondary transition-3d-hover">
                            <span class="fas fa-cog btn-icon__inner"></span>
                          </button>
                        </li>

                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </main>
  </div>
</ng-container>
